import React, { Fragment } from "react"

import { useTranslation } from "react-i18next"

import Skeleton from "@mui/material/Skeleton"
import { Tag } from "@synapse-analytics/synapse-ui"

type Props = {
  type: string | undefined
  size?: "small" | "default" | "xsmall"
  skeletonWidth?: number
  margin?: number | string
}

export function ProjectType(props: Readonly<Props>): React.ReactElement {
  const { type, size = "default", margin, skeletonWidth = 50 } = props
  const { t } = useTranslation("projects")

  // Function to get translated type label
  const getTranslatedType = (typeValue: string): string => {
    const cleanType = typeValue.replace(/_+/g, " ")

    switch (typeValue.toLowerCase()) {
      case "classification":
        return t("filters.classification")
      case "generic":
        return t("filters.generic")
      case "credit_scoring":
      case "credit scoring":
        return t("filters.creditScoring")
      default:
        return cleanType
    }
  }

  const animation: "wave" | "pulse" = "pulse"

  return (
    <Fragment>
      {type ? (
        <Tag
          size={size}
          color={type === "classification" ? "pink" : type === "generic" ? "purple" : "blue"}
          variant="filled"
          style={{
            margin: margin,
          }}
        >
          {getTranslatedType(type)}
        </Tag>
      ) : (
        <Skeleton width={skeletonWidth} animation={animation} style={{ display: "inline-block", margin: margin }} />
      )}
    </Fragment>
  )
}
